import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { SearchButton } from "shared/providers/Layout/components/NewTopBar/components/atoms/SearchButton";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import {
  LoginButton,
  RegisterAndLoginButtonContainer,
  RegisterButton,
} from "./styles";

export const RegisterAndLoginButton = () => {
  const { setState } = useGlobalContext();

  const handleClickLoginButton = () =>
    setState((prev) => ({
      ...prev,
      modal: {
        open: true,
        page: "login",
      },
    }));

  const handleClickRegisterButton = () =>
    setState((prev) => ({
      ...prev,
      modal: {
        open: true,
        page: "register",
      },
    }));

  return (
    <RegisterAndLoginButtonContainer>
      <ComponentErrorBoundary>
        <SearchButton />
      </ComponentErrorBoundary>

      <LoginButton onClick={handleClickLoginButton}>Entrar</LoginButton>

      <RegisterButton onClick={handleClickRegisterButton}>
        Criar conta
      </RegisterButton>
    </RegisterAndLoginButtonContainer>
  );
};
